import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import NewsCard from "@/components/NewsCard";
import Section from "@/components/Section";
import Reveal from "@/components/Reveal";
import { Skeleton } from "@/components/ui/skeleton";
import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/useLanguage";
import { useQuery } from "@tanstack/react-query";
import { fetchLatestPosts, postRowToArticle } from "@/lib/posts";

const LatestNews = () => {
  const { t } = useTranslation();
  const { localize } = useLanguage();

  const { data: rows, isLoading, isError } = useQuery({
    queryKey: ["posts", "latest", 3],
    queryFn: () => fetchLatestPosts(3),
    staleTime: 5 * 60 * 1000,
  });

  const latestArticles = (rows ?? []).map((r) =>
    postRowToArticle(r, localize(`/news/${r.slug}`))
  );

  return (
    <Section
      surface="alt"
      title={t("latestNews.title")}
      containerSize="wide"
      grid
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-8 md:mb-12">
        {isLoading
          ? Array.from({ length: 3 }).map((_, i) => (
              <Skeleton key={i} className="h-80 w-full rounded-lg" />
            ))
          : isError
          ? <p className="col-span-full text-center text-muted-foreground">{t("latestNews.error", "Could not load news.")}</p>
          : latestArticles.map((article, index) => (
              <Reveal key={article.id} delay={index * 120}>
                <NewsCard article={article} showExcerpt={false} className="bg-background/90" />
              </Reveal>
            ))}
      </div>

      <Reveal className="text-center" delay={150}>
        <Button variant="secondary" size="lg" asChild>
          <Link to={localize("/news")}>{t("latestNews.viewAll")}</Link>
        </Button>
      </Reveal>
    </Section>
  );
};

export default LatestNews;
